/* src/interviews/components/AddTime/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';

import { upperFirst } from '../../../../util';
import styles from './styles';

const weekdays = moment.weekdays().map(w => _.lowerFirst(w));

class AddTime extends React.PureComponent {
  constructor(props) {
    super(props);

    const currentTime = moment();
    const remainder = 30 - (currentTime.minute() % 30);
    const date = moment(currentTime).add(remainder, 'minutes');
    const day = date.format('YYYY-MM-DD');
    const time = date.format('HH:mm');

    this.state = {
      multipleStartDate: day,
      multipleStartTime: time,
      multipleEndTime: time,
      repeat: 0,
      ..._.zipObject(weekdays, weekdays.map(() => false)),
      [_.lowerFirst(date.format('dddd'))]: true,
    };

    this._handleSelection = this._handleSelection.bind(this);
    this._onChangeText = this._onChangeText.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
  }

  _handleSelection(day) {
    return (event, checked) => this.setState({ [day]: checked });
  }

  _onChangeText(field) {
    if (field === 'multipleStartDate') {
      return event => {
        const date = moment(event.target.value);
        this.setState({
          multipleStartDate: date.format('YYYY-MM-DD'),
          ..._.zipObject(weekdays, weekdays.map(() => false)),
          [_.lowerFirst(date.format('dddd'))]: true,
        });
      };
    }
    return event => this.setState({ [field]: event.target.value });
  }

  _onClickAdd() {
    const {
      multipleStartDate,
      multipleStartTime,
      multipleEndTime,
      repeat,
    } = this.state;

    const currentDay = moment(multipleStartDate).day();
    this.props.onAddSchedule({
      startDate: multipleStartDate,
      startTime: multipleStartTime,
      endTime: multipleEndTime,
      pattern: {
        repeat,
        shape: _.map(
          [..._.slice(weekdays, currentDay), ..._.slice(weekdays, 0, currentDay)],
          w => this.state[w]
        ),
      },
    });
  }

  renderSelectionControls() {
    const { multipleStartDate } = this.state;
    const current = _.lowerFirst(moment(multipleStartDate).format('dddd'));
    return (
      weekdays.map(day => (
        <Tooltip key={day} title={upperFirst(day)}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state[day]}
                onChange={this._handleSelection(day)}
                value={day}
                disabled={day === current}
                color="primary"
              />
          }
            label={upperFirst(day)[0]}
          />
        </Tooltip>
      ))
    );
  }

  renderMultipleInputs(classes) {
    const { multipleStartTime, multipleStartDate, multipleEndTime, repeat } = this.state;
    return (
      <div className={classes.inputContainer}>
        <TextField
          id="start_date"
          label="Start Date"
          type="date"
          className={classes.textField}
          InputLabelProps={{ shrink: true }}
          value={multipleStartDate}
          onChange={this._onChangeText('multipleStartDate')}
        />
        <TextField
          id="start_time"
          label="Start Time"
          type="time"
          className={classes.textFieldTime}
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 1800 }}
          value={multipleStartTime}
          onChange={this._onChangeText('multipleStartTime')}
        />
        <TextField
          id="end_time"
          label="End Time"
          type="time"
          className={classes.textFieldTime}
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 1800 }}
          value={multipleEndTime}
          onChange={this._onChangeText('multipleEndTime')}
        />
        <TextField
          id="repeat"
          label="Weeks repeated"
          type="number"
          className={classes.textField}
          InputLabelProps={{ shrink: true }}
          value={repeat}
          onChange={this._onChangeText('repeat')}
        />
        <FormControl component="div">
          <FormGroup row>
            {this.renderSelectionControls()}
          </FormGroup>
        </FormControl>
        <Button color="primary" onClick={this._onClickAdd}>Add</Button>
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Typography className={classes.title}>
          Add a New Availability
        </Typography>
        {this.renderMultipleInputs(classes)}
        <Divider />
      </React.Fragment>
    );
  }
}

AddTime.propTypes = {
  classes: PropTypes.object.isRequired,
  onAddSchedule: PropTypes.func.isRequired,
};

export default withStyles(styles)(AddTime);



// WEBPACK FOOTER //
// ./src/modules/interviews/components/AddTime/index.js